<template>

<div class="row pt-2">
    <div class="col-12">
        <div v-if='!sent' >
            <input class="form-control mb-3"
                   v-on:keydown.enter='subscribe'
                   v-model='email'
                   type="email" 
                   placeholder="Enter your e-mail address" />

            <button @click='subscribe' class="btn btn-primary pl-4 pr-4" 
                    :disabled='isLoading'>
                <span v-if='!isLoading'>Subscribe</span>
                <img v-if='isLoading' src='/resources/loader.svg' width='25px'/>
            </button>
        </div>

        <div v-if='sent' class="alert alert-success">
            <div class="alert-icon">
                <span class="icon icon-smile1"></span>
            </div>
            <div class="d-flex justify-content-between align-items-center w-100">
                <div>
                    <span class="text-bold d-block">Done!</span>
                    <span class="text-small">Thank you for subscribing!</span>
                </div>
            </div>
        </div>
    </div>
</div>
   
</template>

<script>
    export default {

        mounted() {

        },

        created() {
            this.setBcLinks([ { name : 'Име на БК', url : 'url' } ]);
        },

        data() {
            return {
                isReady : false,
                sent    : false,
                email   : '',
                isLoading : false,

            }
        },

        methods : {
            
            subscribe() {

                if( this.email.match( this.emailRegex ) == null ) {
                    $.notify('Please provide a valid email address','warning');

                    return;
                }

                this.isLoading = true;

                this.ajax.call('nl:sub', { email : this.email } , (r) => {
                    
                    this.isLoading = false;

                    if( r.status == 'success' ) {

                        this.sent = true;

                    } else {

                        $.notify('Could not subscribe, please try again later','warning');

                    }

                })
            },

        }

    }
</script>
